import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadUser } from 'rubriq/actions';
import { persistRubriqTestimonial } from '../actions';
import SubmitRubriqTestimonial from './SubmitRubriqTestimonial';
var SubmitRubriqTestimonialContainer = function SubmitRubriqTestimonialContainer() {
  var dispatch = useDispatch();
  var curieLoaded = useSelector(function (state) {
    return state.curie.loaded;
  });
  useEffect(function () {
    if (!curieLoaded) {
      dispatch(loadUser());
    }
  }, []);
  var persistTestimonial = function persistTestimonial(payload) {
    return dispatch(persistRubriqTestimonial(payload));
  };
  return /*#__PURE__*/React.createElement(SubmitRubriqTestimonial, {
    persistTestimonial: persistTestimonial
  });
};
export default SubmitRubriqTestimonialContainer;